// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"CheckBox__wrapper___2r6xD"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/widgets/Input/CheckBox.css
 ** module id = 722
 ** module chunks = 0
 **/